var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "company-card-list",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.lock",
              value: _vm.waiting,
              expression: "waiting",
              modifiers: { lock: true },
            },
          ],
          key: _vm.tab,
          ref: "cardlist",
          attrs: {
            companyType: 9,
            batchStarShow: false,
            batchActions: _vm.batchActions,
            list: _vm.cardsList,
          },
          on: {
            "handle-page-num": _vm.handlePageNum,
            "handle-page": _vm.handlePage,
          },
        },
        [
          _c("div", { staticClass: "searchBar" }, [
            _c("span", { staticClass: "font-15-md" }, [
              _vm._v(_vm._s(_vm.listTitle.before)),
              _c(
                "span",
                { staticClass: "blueColor", staticStyle: { color: "#5088FF" } },
                [_vm._v(" " + _vm._s(_vm.listTitle.number) + " ")]
              ),
              _vm._v(_vm._s(_vm.listTitle.after)),
            ]),
          ]),
        ]
      ),
      _c("robot"),
      _c("right-float", { ref: "rightFloat", attrs: { globalRfType: true } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }